import { Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip, Typography } from "@material-ui/core";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';

@observer
class NewUserAlert extends React.Component<any> {

    public parseJSONinfo = (obj: any) => {
        // const compString = obj.Companies.map()
        let compString = '';

        if (obj.Companies.length === 0) {
            compString = '';
        }
        else if (obj.Companies.length === 1) {
            compString = obj.Companies[0]
        }
        else {
            compString = obj.Companies.join(', ')
            // compString = compString.substring(0, compString.length - 2)
        }

        let sitesString = '';
        if (obj.Sites.length === 0) {
            sitesString = '';
        }
        else if (obj.Sites.length === 1) {
            sitesString = obj.Sites[0];
        }
        else {
            sitesString = obj.Sites.join(', ');
            // sitesString = sitesString.substring(0, sitesString.length - 2);
        }

        let pharmacyAccess = 'No';
        let pharmacyRole = 'None';
        if (obj.Pharmacy.Active) {
            pharmacyAccess = 'Yes';
            pharmacyRole = obj.Pharmacy.roles[0].PharmacyRoleName;
        }

        let universityAccess = 'No';
        let universityRoles = 'None';
        if (obj.University.Active) {
            universityAccess = 'Yes';
            universityRoles = obj.University.roles.map((role: any) => role.UniversityRoleName).join(', ');
            // universityRoles = universityRoles.substring(0, universityRoles.length -2);
        }

        return {
            Companies: compString,
            Sites: sitesString,
            pharmacyAccess,
            pharmacyRole,
            universityAccess,
            universityRoles
        }
    }

    public render() {
        const { alert_row } = this.props;
        const data = this.parseJSONinfo(alert_row.AlertJSON);
        return (
            <Grid container={true} spacing={8}>
                <Grid item={true} xs={2}><Typography variant='subtitle2'>New User: </Typography></Grid><Grid item={true} xs={10}><Typography>{alert_row.AlertJSON.FullName}</Typography></Grid>
                <Grid item={true} xs={2}><Typography variant='subtitle2'>Companies: </Typography></Grid><Grid item={true} xs={10}><Typography>{data.Companies}</Typography></Grid>
                <Grid item={true} xs={2}><Typography variant='subtitle2'>Pharmacies: </Typography></Grid><Grid item={true} xs={10}><Typography>{data.Sites}</Typography></Grid>
                <Grid item={true} xs={3}><Typography variant='subtitle2'>Pharmacy Access: </Typography></Grid><Grid item={true} xs={2}><Typography>{data.pharmacyAccess}</Typography></Grid>
                <Grid item={true} xs={2}><Typography variant='subtitle2'>Pharmacy Role: </Typography></Grid><Grid item={true} xs={5}><Typography>{data.pharmacyRole}</Typography></Grid>
                <Grid item={true} xs={3}><Typography variant='subtitle2'>University Access: </Typography></Grid><Grid item={true} xs={2}><Typography>{data.universityAccess}</Typography></Grid>
                <Grid item={true} xs={2}><Typography variant='subtitle2'>University Role: </Typography></Grid><Grid item={true} xs={5}><Typography>{data.universityRoles}</Typography></Grid>
            </Grid>
        );
    }
}

export default (
    withRouter(NewUserAlert)
);


// WEBPACK FOOTER //
// ./src/modules/dashboard/Widgets/Alerts/NewUserAlert.tsx